export interface Location {
  location: string;
  locationType: LocationType;
  postcode: number | null;
  latitude: number;
  longitude: number;
  numSettled: null | number;
  avgAmountSettled: null | number;
  amountSettled: null | number;
  annualEnergyGeneratedGigawatthours: null | number;
  numDistinctAddressSettled: null | number;
  avgTotalPanelsCapacityKilowatt: null | number;
  sumTotalPanelsCapacityKilowatt: null | number;
  numSettledAllSolar: null | number;
  numSettledAllBatteries: null | number;
  numSettledAllElectricVehicles: null | number;
  numSettledBatteries: null | number;
  numSettledSolarSystem: null | number;
  numSettledSolarSystemAndBatteryCombo: null | number;
  numSettledSolarInverters: null | number;
  numSettledSolarPoolHeatingSystems: null | number;
  numSettledSolarPanels: null | number;
  numSettledSolar: null | number;
  numSettledBatteryStorage: null | number;
  numSettledSolarAndBatterySystem: null | number;
  numSettledAirConditioningAndVentilation: null | number;
  numSettledEvChargingInfrastructure: null | number;
  numSettledEfficientElectricStoveTops: null | number;
  numSettledElectricHeatingAndCoolingSystemsReverseCycle: null | number;
  numSettledHotWaterHeatPumpsHwhp: null | number;
  numSettledElectricVehicles: null | number;
  numSettledElectricCarNew: null | number;
  numSettledElectricCarUsed: null | number;
  numSettledHydronicHeatPumps: null | number;
  numSettledInsulation: null | number;
  numSettledElectricMotorbikeNew: null | number;
  numSettledElectricMotorbikeUsed: null | number;
  lastUpdatedAt: string;
}

export type LocationType = 'Suburb' | 'Region' | 'State';

export type TotalProductsType = {
  name: string;
  total: number;
  key: keyof Location;
};

export type ThemeType = 'primary' | 'secondary' | 'tertiary';

export enum MapType {
  Marker = 'MARKER',
  Heat = 'HEAT'
}
